import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { filter, interval } from 'rxjs';
import { MS_TEN_MINUTES, S_FOUR_WEEKS } from './time';
import { SubSink } from 'subsink';
import { VERSION_UPDATE_POLLING_FREQUENCY_IN_MS } from './global.constants';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {

  newVersionDetected = false;
  newVersionReady = false;
  newVersionInstallFailed = false;
  showNewVersionModal = false;
  updating = false;

  subs = new SubSink();

  constructor(private swUpdate: SwUpdate) {}

  watchForUpdates() {
    this.subs.unsubscribe();
    this.subs.sink = this.swUpdate.versionUpdates
      .subscribe((e) => {
        console.log(`[SW DEBUG]`, e);
        if (e.type === 'VERSION_DETECTED') {
          this.newVersionDetected = true;
        } else if (e.type === 'VERSION_READY') {
          this.newVersionReady = true;
          this.showNewVersionModal = true;
        } else if (e.type === 'VERSION_INSTALLATION_FAILED') {
          this.newVersionInstallFailed = true;
        }

      });

    // Subscribe to updates in the online status

    // Poll for updates every 15 minutes after waiting for the app to stabalize
    // const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const updatePollingSubscription$ = interval(VERSION_UPDATE_POLLING_FREQUENCY_IN_MS);

    this.subs.sink = updatePollingSubscription$.subscribe(async () => {
      try {
        await this.swUpdate.checkForUpdate();
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });

    this.subs.sink = this.swUpdate.unrecoverable.subscribe((event) => {
      console.warn(`[SW DEBUG] Unrecoverable: ${event.reason}`, event);
    });
  }

  updateApplication(): void {
    this.updating = true;
    window.location.reload();
  }

  dismissVersionUpdate() {
    this.showNewVersionModal = false;
    console.log(`[SW DEBUG] Update snoozed ten minutes`);

    setTimeout(() => {
      if (this.newVersionReady) {
        this.showNewVersionModal = true;
      }

    }, MS_TEN_MINUTES)

  }
}
